import { gsap, Back } from "gsap";
/* animations */
import anime from "animejs";
// import anime from "animejs";

/**
*
* @param {HTMLElement | null} itemsSelector
*/
export function appAnimateMenuItemsOnHover(itemsSelector) {
  if (itemsSelector !== null) {
    const menuItems = gsap.utils.toArray(".app-menu-item");

    menuItems.forEach((item) => {
      item.addEventListener("mouseenter", () => {
        gsap.to(item, { color: item.dataset.color, duration: 0.24, ease: Back.easeOut(2) });
      });

      item.addEventListener("mouseleave", () => {
        gsap.to(item, { color: "inherit", duration: 0.24, ease: Back.easeOut(2) });
      });
    });
  }

  // menu mobil
  let isOpen = false;
  const idOpenButton = "mobile-menu-open";
  const idCloseButton = "mobile-menu-close";
  const idBackdrop = "mobile-menu-backdrop";
  const idLayout = "mobile-menu-layout";
  const idwmenu = "cont-menu";
  const classMenuItems = ".mobile-menu-item";

  const openButton = document.getElementById(idOpenButton);
  const closeButton = document.getElementById(idCloseButton);
  const backdrop = document.getElementById(idBackdrop);
  const layout = document.getElementById(idLayout); 
  const wmenu = document.getElementById(idwmenu);
  const menuItems = document.querySelectorAll(classMenuItems);

  const animationClose = anime
    .timeline({
      targets: menuItems,
      easing: "easeInOutExpo",
      opacity: [1, 0],
      duration: 400,
      autoplay: false,
      complete: function () {
        isOpen = false;
      },
    })
    .add(
      {
        targets: layout,
        easing: "easeInOutExpo",
        height: ["100%", 0],
        duration: 600,
      },
      "+=200"
    )
    .add(
      {
        targets: wmenu,
        width: ["100%"],
      },
    )
    .add(
      {
        targets: backdrop,
        easing: "easeInOutExpo",
        opacity: [1, 0],
        duration: 400,
      },
      "-=100"
    )
    .add(
      {
        targets: backdrop,
        easing: "easeInOutExpo",
        height: ["100%", 0],
        duration: 100,
      },
      "+=200"
    );

  const animationOpen = anime
    .timeline({
      targets: backdrop,
      easing: "easeInOutExpo",
      autoplay: false,
      height: [0, "100%"],
      duration: 1,
      complete: function () {
        isOpen = true;
      },
    })
    .add({
      targets: backdrop,
      easing: "easeInOutExpo",
      height: [0, "100%"],
      opacity: [0, 1],
      duration: 200,
    })
    .add(
      {
        targets: layout,
        easing: "easeInOutExpo",
        height: [0, "100%"],
        opacity: [0, 1],
        duration: 600,
      },
      "-=100"
    )
    .add(
      {
        targets: wmenu,
        width: ["272px"],
      },
    )
    .add(
      {
        targets: menuItems,
        easing: "easeInOutExpo",
        translateY: ["-100px", 0],
        opacity: [0, 1],
        duration: 400,
        delay: function (el, i, l) {
          return i * 100;
        },
      },
      "-=400"
    );

  // sets the animation
  openButton.onclick = function () {
    if (!isOpen) {
      animationOpen.play();
    }
  };

  // sets the animation
  closeButton.onclick = function () {
    if (isOpen) {
      animationClose.play();
    }
  };

}
